import { webRequest } from '@utils/request';

export async function refreshJavaWebEntityInSession(): Promise<void> {
	await webRequest.post(`/session/refresh-java-web-entity-in-session`);
}
